import React, { useState } from 'react';
import './RegisterModal.css'; // You will create this CSS file to match the design
import Select from 'react-select';

const denticonPMSType = 'denticon';

const RegisterModal = ({ onClose, onRegister, onChange, formData, serviceName, tc, pmsType }) => {

  const carriers = [
    "ADN Administrators",
    "Alignment Health Plan",
    "Altus Dental",
    "AmeriPlan",
    "Arkansas Blue Cross Blue Shield",
    "Best Life And Health",
    "Blue Cross Blue Shield",
    "Blue Cross Blue Shield of Georgia",
    "Blue Cross Blue Shield of Nebraska",
    "Blue Cross Blue Shield of North Carolina",
    "Blue Cross Blue Shield of Rhode Island",
    "Blue Cross Blue Shield of Wyoming",
    "Blue Cross of Idaho",
    "Blue Shield of California",
    "BridgeSpan",
    "California Dental",
    "CBA Blue",
    "Companion Life",
    "DeCare Dental",
    "Delta Dental",
    "DenCap",
    "Dental Care Plus",
    "Dental Health Options",
    "Dental Source",
    "DentaQuest",
    "Dominion National",
    "EmblemHealth (formerly known as GHI)",
    "Excellus Blue Cross Blue Shield",
    "FCL Dental (First Continental Life)",
    "First Dental Health",
    "GEHA",
    "Golden Dental Plans",
    "Group Health Cooperative of Eau Claire",
    "Health Plan of San Mateo",
    "HealthChoice of Michigan",
    "HealthFirst (NY)",
    "HealthPartners",
    "Horizon Blue Cross Blue Shield of New Jersey",
    "Humana",
    "Illinicare Health",
    "Keystone First",
    "LifeMap",
    "MassHealth",
    "Medical Mutual",
    "Mercy Care",
    "MVP Health Care",
    "North Carolina Health Choice (NCHC) for Children",
    "NY State No-Fault",
    "Paramount Healthcare",
    "Passport Health Plan (Kentucky)",
    "Patriot Health",
    "Peach State Health Plan",
    "Premier Dental Group",
    "PrimeWest Health",
    "Quality Plan Administrators",
    "Renaissance Dental",
    "Rockefeller Health Plan (Dental)",
    "Sierra Health and Life",
    "SoonerCare (Oklahoma Medicaid)",
    "TruAssure",
    "UniCare",
    "Vantage One",
    "WEA Trust",
    "Wellcare",
    "Aflac",
    "Access Dental",
    "1199SEIU",
    "Aetna",
    "Alameda Alliance for Health",
    "AmeriGroup",
    "Ameritas",
    "Assurant Employee Benefits",
    "Avesis",
    "Basix Dental Discount",
    "Blue Cross Blue Shield Federal Employee Program",
    "Blue Cross Blue Shield of Alabama",
    "Blue Cross Blue Shield of Louisiana",
    "Blue Cross Blue Shield of South Carolina",
    "Blue Cross Blue Shield of Texas",
    "Capital Blue Cross",
    "CareFirst Blue Cross Blue Shield (Dental)",
    "CareOregon",
    "Cigna",
    "Colonial Life",
    "CompBenefits",
    "Connecticut Dental Health Partnership",
    "Connection Dental",
    "Coventry Dental",
    "Culinary Health Fund",
    "Dearborn National",
    "Denex Dental",
    "Dental Health & Wellness",
    "Dental Health Alliance",
    "Dental Health Services",
    "Dental Select",
    "DentalWise",
    "Elderplan",
    "FCL Dental (StarDent)",
    "Fidelis Care (NY)",
    "Florida Blue: Blue Cross Blue Shield of Florida",
    "Hawaii Medical Service Association (HMSA)",
    "Healthplex",
    "Highmark Blue Cross Blue Shield of Delaware",
    "Horizon NJ Health",
    "Indiana Medicaid",
    "Itasca Medical Care",
    "Lifetime Benefit Solutions",
    "Lincoln Financial Group",
    "Medicare",
    "MetLife",
    "Mississippi Division of Medicaid",
    "Mutual of Omaha",
    "Nationwide",
    "PacificSource Health Plans",
    "PBA (Patrolmen's Benefit Association)",
    "Physicians Health Plan of Northern Indiana",
    "Physicians Mutual",
    "Principal Financial Group",
    "Priority Health",
    "Public Employees Health Program (PEHP)",
    "Regence Blue Cross Blue Shield",
    "Sele-Dent",
    "SelectHealth",
    "Solstice",
    "Southland Benefit Solutions",
    "Superior Dental Care",
    "Texas Children's Health Plan",
    "Tricare Dental Program",
    "Triple-S Salud: Blue Cross Blue Shield of Puerto Rico",
    "United Concordia",
    "UnitedHealthcare",
    "Advantica",
    "Affinity Health Plan",
    "Alpha Dental",
    "Anthem Blue Cross",
    "APWU",
    "Argus Dental",
    "Beam",
    "Benefit Management Inc",
    "Benefit Source",
    "Blue Cross Blue Shield of Arizona",
    "Blue Cross Blue Shield of Illinois",
    "Blue Cross Blue Shield of Kansas City",
    "Blue Cross Blue Shield of Massachusetts",
    "Blue Cross Blue Shield of Michigan",
    "Blue Cross Blue Shield of New Mexico",
    "Blue Cross Blue Shield of Oklahoma",
    "Blue Shield of Northeastern New York",
    "BMC HealthNet Plan",
    "Boston University",
    "Buckeye Health Plan",
    "Clover Health",
    "Commonwealth Care Alliance",
    "Comprehensive Medical and Dental Program (CMDP)",
    "Connect Care",
    "DAKOTACARE",
    "DDS Inc.",
    "Dental Network of America",
    "Denti-Cal",
    "EmblemHealth (formerly known as HIP)",
    "Emory Health Care Plan",
    "Fallon Community Health Plan (FCHP)",
    "Fidelio Dental",
    "Guardian",
    "GWH-Cigna (formerly Great West Healthcare)",
    "Health Choice Arizona",
    "Health Plan of Nevada",
    "HealthSmart",
    "Highmark Blue Cross Blue Shield of Western New York",
    "Highmark Blue Shield",
    "Independence Blue Cross",
    "J.J. Stanis and Company",
    "Kaiser Permanente",
    "MediPass",
    "Molina Healthcare",
    "OneNet",
    "Option One",
    "Phoenix Health Plan",
    "Premier Access",
    "Prominence Health Plan",
    "Reliance Standard",
    "Scion Dental",
    "Security Life",
    "STLDentalPlan",
    "Stratose",
    "Sun Life Financial",
    "TDA (Total Dental Administrators)",
    "Teachers Health Trust",
    "UCare",
    "Wellmark Blue Cross Blue Shield",
    "UNUM",
    "USAble Mutual Insurance Company",
    "Vision Plan of America",
    "Western Dental & Orthodontics",
    "AIG",
    "AlwaysCare",
    "Anthem Blue Cross Blue Shield",
    "Asuris Northwest Health",
    "Aultcare",
    "Blue Choice Health Plan",
    "Blue Cross Blue Shield of Kansas",
    "Blue Cross Blue Shield of North Dakota",
    "Blue Cross Blue Shield of Tennessee",
    "Bridgeway Health Solutions",
    "Careington",
    "CareSource",
    "Community First Health Plans",
    "Dental Benefit Providers",
    "Dentegra",
    "Dentemax",
    "Deseret Mutual",
    "EmblemHealth",
    "EMI Health",
    "Empire Blue Cross Blue Shield (Dental)",
    "Encore Dental",
    "First Choice Health",
    "Geisinger Health Plan (Dental)",
    "Golden West Dental",
    "Harvard Pilgrim Health Care",
    "Hawaii Dental Service (Delta Dental)",
    "Health Net",
    "HealthChoice",
    "Highmark Blue Cross Blue Shield",
    "KanCare",
    "Legacy Health",
    "Level",
    "Liberty Dental",
    "LifeWise",
    "MaineCare",
    "MCNA Dental",
    "Medica",
    "Medicaid",
    "MetroPlus Health Plan",
    "Minuteman Health",
    "Moda Health",
    "My Smile Dental Plan",
    "Network Health Plan",
    "Nevada Dental Benefits",
    "OneNet PPO",
    "Oscar Health Insurance Co.",
    "Passport To Health (Montana Medicaid)",
    "PeachCare for Kids",
    "Premera Blue Cross",
    "Primary Care Case Management (North Dakota Medicaid)",
    "SecureCare Dental",
    "Starmount Insurance",
    "The Standard",
    "Tufts Health Plan",
    "Union Plans",
    "United Federation of Teachers",
    "UnitedHealthcare Community Plan",
    "UnitedHealthcare Oxford",
    "UPMC Health Plan",
    "Workers' Compensation",
    "Willamette Dental Group"
  ];

  const insuranceOptions = [
    {
      label: "Common Insurances",
      options: [
        {value:'Delta Dental', label: "Delta Dental"},
        {value:'Guardian', label: "Guardian"},
        {value:'MetLife', label: "MetLife"},
        {value:'Cigna',  label: "Cigna"},
        {value:'Aetna', label: "Aetna"},
        {value:'UnitedHealthcare', label:"UnitedHealthcare"}
      ]
    },
    {
      label: "All Insurances",
      options: carriers.map(carrier => ({ value: carrier, label: carrier }))
    }
  ];
  const genderOptions = [
    {value: 'Unspecified', label: 'Unspecified'},
    {value: 'Female', label: 'Female'},
    {value: 'Male', label: 'Male'},
  ];

  const [selectedInsurance, setSelectedInsurance] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [selectedGender, setSelectedGender] = useState(genderOptions[0]);

  const handleInsuranceChange = (selectedOption) => {
    setSelectedInsurance(selectedOption);
    setValidationError(false); // Reset validation error when user selects an option
    onChange({target : {name : 'insurance', value : selectedOption.value}})
  };

  const handleGenderChange = (selectedOption) => {
    setSelectedGender(selectedOption);
    // setValidationError(false); // Reset validation error when user selects an option
    onChange({target : {name : 'gender', value : selectedOption.value}})
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (!selectedInsurance) {
      setValidationError(true); // User tried to submit without selecting insurance
    } else {
      onRegister(formData); // Proceed with the form submission
    }
  };
  
  return (
    <div className="modal-backdrop">
      <div className="register-modal">
        <div className="modal-header">
          <h2>{serviceName} Appointment</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-content">
          <p>Please enter your name and email address so that we can send you the confirmation email for your appointment.</p>
          <p>We accept all PPO dental insurances Chat with us if you have any questions.</p>
          <form onSubmit={handleFormSubmit}>
            <input 
              type="text" 
              name="fullName" 
              placeholder="Full Name" 
              value={formData.fullName} 
              onChange={onChange} 
              required 
            />
            <input 
              type="email" 
              name="email" 
              placeholder="Email" 
              value={formData.email} 
              onChange={onChange} 
              required 
            />
            <input 
              type="tel" 
              name="phoneNumber" 
              placeholder="Phone number" 
              value={formData.phoneNumber} 
              onChange={onChange} 
              required 
            />
            {pmsType === denticonPMSType && (
              <input
                type="date"
                name="dob"
                placeholder="Date of Birth"
                value={formData.dob}
                onChange={onChange}
                required
              />
            )}
            {pmsType === denticonPMSType && (
              <Select
                options={genderOptions}
                value={selectedGender}
                defaultValue={insuranceOptions[0]}
                onChange={handleGenderChange}
                placeholder="Select Gender..."
                isSearchable={true}
                className="gender-select"
              />
            )}
            <div className="insurance-select-container">
              <Select
                options={insuranceOptions}
                value={selectedInsurance}
                onChange={handleInsuranceChange}
                placeholder="Select insurance..."
                isSearchable={true}
              className="insurance-select"
            />
            {validationError && <p className="error-message">Please select an insurance carrier.</p>}
          </div>
            { tc && <div className="terms-container">
              <input type="checkbox" id="terms" name="terms" required />
              <label htmlFor="terms">By signing-up you agree to the <a href={tc} target="_blank" rel="noopener noreferrer" className="terms-link">
              terms and conditions
          </a>.</label>
            </div> }
            <button type="submit" className="confirm-button">Confirm</button>
          </form>
          <div className="login-prompt">
            Already have an account? <span onClick={onClose}>Login</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
